import React from "react";
import classes from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import deeplink from "../../../../../utils/deeplink";
import { FullSwiper } from "../../../moduleable/components/swiper";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default props => {
	useStyles(classes)
    const { bannerData } = props;
    const { width = 414, height = 386, banners } = bannerData;
	const aspectRatio = width && height ? `${width} / ${height}` : undefined

    let pagination = {
        clickable: true
    };

	return <div className={classes.CLogBanner}>
		<FullSwiper items={banners} style={{
			aspectRatio,
			backgroundColor: '#f1f1f1'
		}} options={{
			pagination: banners?.length > 1 && pagination,
		}} render={(item, index) => {
			return <a className={classes.BannerHref} href={deeplink(item?.deepLink, "msite")} key={index}>
				{
					banners?.length > 1 ? <img alt="CLog" src={item?.image} /> : <LazyLoadImage alt="CLog" src={item?.image} />
				}
			</a>
		}} />
	</div>
}
